export default __webpack_public_path__ + "static/media/wallpaper-environment.a5436d13.jpg";